import { render, staticRenderFns } from "./ToggleSwitcher.vue?vue&type=template&id=0753cef2&scoped=true&"
import script from "./ToggleSwitcher.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ToggleSwitcher.vue?vue&type=style&index=0&id=0753cef2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753cef2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCardText,VCol,VSwitch})
